import { useContext } from 'react'
import { useFirestoreGeneral } from '../../../firebase/useFirestore'
import { SavedIcon } from '../../../StateManagment/SavedIcon'
import { Auth } from '../../../StateManagment/Auth'
import Location from '../../../hooks/Location'
import useSettings from '../../../hooks/Settings.jsx'
import { db, timestamp } from '../../../firebase/config'
import ReadOnlyGuard from '../../common/ReadOnlyGuard'

/**
 * De sectie 'SMS' op het tabblad Gegevens van een huishouden: heeft het
 * huishouden toestemming gegeven om SMS-herinneringen te ontvangen?
 *
 * Hier en niet bij de afspraak: de automatische herinnering wordt aangemaakt
 * op het moment van inplannen, zonder dat iemand een vinkje zet. Die vlag mag
 * dan alleen 'ja' zijn als het huishouden dat zelf ooit heeft gezegd, en dat
 * hoort bij het huishouden. Vastgelegd met wie en wanneer (`SmsConsentBy`,
 * `SmsConsentAt`), zoals het vinkje bij een handmatige herinnering.
 *
 * Alleen zichtbaar als SMS-herinneringen voor de organisatie aanstaan: zonder
 * dat doet de vlag niets, en een vinkje dat niets doet is verwarrender dan geen.
 * Tijdens het laden niets: een vinkje dat 'uit' zegt terwijl we het niet weten
 * zou een klik uitlokken die iets wegschrijft wat niemand koos.
 * AI-CONTEXT: See docs/pitfalls.md#state-gate-defaults-open-while-loading
 * AI-CONTEXT: See docs/features/default-housevisit-reminders.md
 *
 * @returns {JSX.Element|null}
 */
const HouseholdSmsConsentCard = () => {
    const [, setSaved] = useContext(SavedIcon)
    const [auth] = useContext(Auth)
    const adressId = Location()[3]
    const { smsRemindersEnabled } = useSettings()

    const adressList = useFirestoreGeneral('Adresses', 'ID', adressId || '')
    const adress = Array.isArray(adressList) && adressList.length > 0 ? adressList[0] : null

    if (!smsRemindersEnabled) return null
    if (!adress) return null

    /** @param {React.ChangeEvent<HTMLInputElement>} e */
    const consentHandler = async (e) => {
        const checked = e.target.checked
        await db.collection('Adresses').doc(adress.docid).update({
            SmsConsent: checked,
            SmsConsentBy: auth?.ID || 'unknown',
            SmsConsentAt: timestamp,
        })
        setSaved('flex')
    }

    return (
        <div className="dashboard-container adress-household-sms-consent">
            <h3>SMS</h3>
            <ReadOnlyGuard edit="addresses.edit">
                <label className="sms-consent-label">
                    <input
                        type="checkbox"
                        checked={adress.SmsConsent === true}
                        onChange={consentHandler}
                    />
                    Toestemming voor SMS-herinneringen
                </label>
            </ReadOnlyGuard>
        </div>
    )
}

export default HouseholdSmsConsentCard
